// extracted by mini-css-extract-plugin
export default {"content":"PatternList_content__P2UgQ"};